import React, { Component, createRef } from "react";
import { addDays, differenceInCalendarDays, format } from "date-fns";

// import { getAirlines } from "../../../../lib/getAirlines";
import cf from "../../../../lib/utils/common";
import commonFunction from "../../../../lib/utils/common";
import B2BWidgets from "../../../b2bwidgets/theme4/mobile/index";
import MobileCalender from "../../../calendar/flightCalender/theme4/MobileCalender";
import MultiSuppilerDropDownoption from "../../../multiDropdown/theme4/mobile";
import MultiSelectDropDown from "../../../multiselectMobile/multiSelectDropDownMobile";
import FlightAutoComplete from "./FlightAutoComplete";
import PaxConfig from "./PaxConfig";
import { getUrl, parseurl } from "../../../../lib/flight/urlParser";
import { getSupplierList } from "../../../../lib/getSupplierList";

const cabinClass = [
  { id: 1, value: "Economy", label: "Economy" },
  { id: 2, value: "Business", label: "Business" },
  { id: 3, value: "First Class", label: "First Class" },
  { id: 4, value: "Premium Economy", label: "Premium Economy" },
];

const rbdClass = [
  { label: "All", value: "*", isChecked: false },
  { label: "A", value: "A", isChecked: false },
  { label: "B", value: "B", isChecked: false },
  { label: "C", value: "C", isChecked: false },
  { label: "D", value: "D", isChecked: false },
  { label: "E", value: "E", isChecked: false },
  { label: "F", value: "F", isChecked: false },
  { label: "G", value: "G", isChecked: false },
  { label: "H", value: "H", isChecked: false },
  { label: "I", value: "I", isChecked: false },
  { label: "J", value: "J", isChecked: false },
  { label: "K", value: "K", isChecked: false },
  { label: "L", value: "L", isChecked: false },
  { label: "M", value: "M", isChecked: false },
  { label: "N", value: "N", isChecked: false },
  { label: "O", value: "O", isChecked: false },
  { label: "P", value: "P", isChecked: false },
  { label: "Q", value: "Q", isChecked: false },
  { label: "R", value: "R", isChecked: false },
  { label: "S", value: "S", isChecked: false },
  { label: "T", value: "T", isChecked: false },
  { label: "U", value: "U", isChecked: false },
  { label: "V", value: "V", isChecked: false },
  { label: "W", value: "W", isChecked: false },
  { label: "X", value: "X", isChecked: false },
  { label: "Y", value: "Y", isChecked: false },
  { label: "Z", value: "Z", isChecked: false },
];

let TripType = [
  { id: 1, value: "oneWay", label: "One Way" },
  { id: 2, value: "roundTrip", label: "Round Trip" },
  { id: 3, value: "Multicity", label: "Multicity" },
];

const DepartureTime = [
  { label: "All", value: "All", isChecked: true, code: "" },
  {
    label: "Before 6 AM",
    value: "Before 6 AM",
    isChecked: false,
    code: "00000559",
  },
  {
    label: "6 AM - 12 PM",
    value: "6 AM - 12 PM",
    isChecked: false,
    code: "06001159",
  },
  {
    label: "12 PM - 6 PM",
    value: "12 PM - 6 PM",
    isChecked: false,
    code: "12001759",
  },
  {
    label: "After 6 PM",
    value: "After 6 PM",
    isChecked: false,
    code: "18002359",
  },
];

let airline = [];
const todaysDate = format(new Date(), "dd-LLL-yyyy");
export default class Theme1 extends Component {
  constructor(props) {
    super(props);
    this.setState = this.setState.bind(this);
    this.guestDetailWrapper = createRef();
    this.economyPopUpWrapper = createRef();
    this.advanceSearchWrapper = createRef();
    this.passengerDropdownWrapper = createRef();
    this.travellerCabin = createRef();
    this.multicityDepartureWrapper = createRef();
    this.multicityReturnWrapper = createRef();
    this.multicityClassWrapper = createRef();
    this.departureListWrapper = createRef();
    this.returnListWrapper = createRef();

    this.state = {
      departureAirPortName: "",
      goingToAirPortName: "",
      isOnewaySearch: true,
      departureValue: "",
      goingToValue: "",
      expandDepartureBoolean: false,
      expandGoingToBoolean: false,
      departureDateValue: format(new Date(), "dd-LLL-yyyy"),
      goingToDateValue: format(addDays(new Date(), 7), "dd-LLL-yyyy"),
      expandDepartureDateBoolean: false,
      expandGoingToDateBoolean: false,
      paxAdultValue: 1,
      paxChildrenValue: 0,
      paxInfantValue: 0,
      SelectedClassValue: { label: "Economy", id: 1 },
      openCabinClassList: false,
      getDepartureSuggestionList: [],
      getGoingToSuggestionList: [],
      getDepartureAirportCode: "",
      getGoingToAirportCode: "",
      openCabinClassListOne: false,
      isError: {
        departure: false,
        goingTo: false,
        departureDate: false,
        goingToDate: false,
      },
      returnCity: "",
      departureCity: "",
      isMultiCitySearch: false,
      openPaxList: false,
      guest_id: "",
      FlightData: [
        {
          flight: 1,
          src: "",
          srcValue: "",
          dest: "",
          destValue: "",
          showsrcDropdown: false,
          showdestDropdown: false,
          departureDate: format(new Date(), "dd-LLL-yyyy"),
          returnDate: format(addDays(new Date(), 7), "dd-LLL-yyyy"),
          showdepartureDateDropdown: false,
          showreturnDateDropdown: false,
          advancesearch: {
            airlines: [],
            fcs: JSON.parse(JSON.stringify(rbdClass)),
            dtym: JSON.parse(JSON.stringify(DepartureTime)),
            cabinclass: { label: "Economy", id: 1 },
            showCabinClassList: false,
          },
          flexiBaggage: true,
          error: {
            destErrMsg: "",
            srcErrMsg: "",
            rbdCabinErrMsg: "",
          },
          bagreq: true,
          odt: cf.getDateWithFormat(new Date(), this?.props?.dateFormat),
          disabledDate: cf.getDateWithFormat(
            new Date(),
            this?.props?.dateFormat
          ),
        },
      ],
      travellerCabinClass: { label: "Economy", id: 1 },
      travellerCabin: false,
      selectedTripType: "oneWay",
      showTraveller: false,
      pax: {
        adults: 1,
        child: 0,
        infants: 0,
      },
      isAdvanceSearch: false,
    };

    this.box = createRef(null);
  }
  componentDidMount() {
    let FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));
    console.log("isSRP", this.props.isSRP, this.props);

    if (this.props.isSRP) {
      if (this.props.FlightData && this.props.FlightData.length) {
        this.setState({
          FlightData: this.props.FlightData,
        });
        this.props.FlightData.forEach((flightObj, id) => {
          console.log(
            "🚀 ~ file: index.js:171 ~ Theme1 ~ this.props.FlightData.forEach ~ flightObj:",
            flightObj
          );
          if (this.props.tripType !== "1" && id !== 0) {
            flightObj.disabledDate =
              this.props.FlightData[id - 1].departureDate;
            console.log("flightObj.disabledDate", flightObj.disabledDate);
          }
          // rbd Class
          let rbdClass1 = JSON.parse(JSON.stringify(rbdClass));
          if (flightObj.advancesearch.fcs.length) {
            let tempOptions = flightObj.advancesearch.fcs;
            let temprdbOptions = JSON.parse(JSON.stringify(rbdClass));
            for (let i = 0; i < temprdbOptions.length; i++) {
              if (tempOptions.includes(temprdbOptions[i].value)) {
                temprdbOptions[i].isChecked = true;
              }
            }
            rbdClass1 = temprdbOptions;
          }
          flightObj.advancesearch.fcs = rbdClass1;
          // rbd Class

          // dtym Class
          let departureTime = JSON.parse(JSON.stringify(DepartureTime));
          if (flightObj.advancesearch.dtym.length) {
            let tempOptions = flightObj.advancesearch.dtym;
            console.log("tempOptionsfgh", tempOptions);

            let temprdbOptions = JSON.parse(JSON.stringify(DepartureTime));
            if (!tempOptions[0]) {
              tempOptions[0] = "All";
            }
            for (let i = 0; i < temprdbOptions.length; i++) {
              // console.log("tempOptions.includes(temprdbOptions[i].value",tempOptions.includes(temprdbOptions[i].code))
              if (tempOptions.includes(temprdbOptions[i].code)) {
                temprdbOptions[i].isChecked = true;
              } else {
                temprdbOptions[i].isChecked = false;
              }
            }

            departureTime = temprdbOptions;
          }
          flightObj.advancesearch.dtym = departureTime;
          // dtym Class
          let tempCambin =
            flightObj.advancesearch.cabinclass &&
            typeof flightObj.advancesearch.cabinclass == "string"
              ? cabinClass.find(
                  (ele) => ele.id == flightObj?.advancesearch?.cabinclass
                )
              : flightObj.advancesearch.cabinclass;

          // cabin Class
          if (
            flightObj.advancesearch.cabinclass &&
            typeof flightObj.advancesearch.cabinclass == "string"
          ) {
            flightObj.advancesearch.cabinclass = JSON.parse(
              JSON.stringify(tempCambin)
            ) || { label: "Economy", id: 1 };
          }
          // cabin Class
          // cabin Class
          if (id == 0 && flightObj.advancesearch.cabinclass) {
            this.setState(
              {
                travellerCabinClass: JSON.parse(JSON.stringify(tempCambin)) || {
                  label: "Economy",
                  id: 1,
                },
              },
              () => {
                console.log(
                  "🚀 ~ file: index.js:221 ~ Theme1 ~ this.props.FlightData.forEach ~ travellerCabinClass:",
                  this.state.travellerCabinClass,
                  flightObj?.advancesearch?.cabinclass
                );
              }
            );
          }
        });
        FlightDataCopy = JSON.parse(JSON.stringify(this.props.FlightData));
        console.log("🚀 ~ FlightDataCopy1:", FlightDataCopy);
      }
      let trip =
        TripType.find((ele) => ele.id == this.props.tripType) || TripType[0];
      console.log(
        "🚀 ~ file: index.js:198 ~ Theme1 ~ componentDidMount ~ trip:",
        this.props.pax
      );

      this.setState({
        selectedTripType: trip.value,
        isAdvanceSearch: this.props.isAdvanceSearch,
        pax: this.props.pax,
        guest_id: this.props.guest_id || "",
      });
    }
    // this.setState({
    //   getDepartureSuggestionList: this.props.airports,
    //   getGoingToSuggestionList: this.props.airports,
    //   goingToValue: new URLSearchParams(window.location.search).get('to') && new URLSearchParams(window.location.search).get('toCity') ? new URLSearchParams(window.location.search).get('toCity') + " - (" + new URLSearchParams(window.location.search).get('to') + ")" : '',
    //   getGoingToAirportCode: new URLSearchParams(window.location.search).get('to') ? new URLSearchParams(window.location.search).get('to') : "",
    //   returnCity: new URLSearchParams(window.location.search).get('toCity') ? new URLSearchParams(window.location.search).get('toCity') : ''
    // })

    getSupplierList().then((res) => {
      console.log("getAirlines===>res===>", res);
      if (res.data && res.data.airlines && res.data.airlines.length > 0) {
        airline = res.data.airlines.map((ele, id) => {
          return {
            label: ele.name,
            value: ele.code,
            isChecked: false,
            displayValue: ele,
          };
        });
        airline.unshift({
          label: "All",
          value: "*",
          isChecked: false,
          displayValue: "All",
        });

        FlightDataCopy.forEach((element) => {
          let tempOptions = element.advancesearch.airlines;
          let temprdbOptions = JSON.parse(JSON.stringify(airline));
          for (let i = 0; i < temprdbOptions.length; i++) {
            if (tempOptions.includes(temprdbOptions[i].value))
              temprdbOptions[i].isChecked = true;
          }
          airline = temprdbOptions;
          element.advancesearch.airlines = JSON.parse(JSON.stringify(airline));
        });
        console.log("🚀 ~ FlightDataCopy:", FlightDataCopy);

        this.setState({
          FlightData: FlightDataCopy,
        });
      }
    });
    document.addEventListener("mousedown", this.handleClickOutside);
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  flexiBaggageHandler(index) {
    const FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));
    FlightDataCopy[index][`flexiBaggage`] =
      !FlightDataCopy[index][`flexiBaggage`];
    this.setState({ FlightData: FlightDataCopy });
  }

  // Autocomplete functions
  onclickFlightAutoComplete(type, i) {
    const FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));
    FlightDataCopy[i][`${type}Value`] = "";
    FlightDataCopy[i].error[`${type}ErrMsg`] = "";
    this.setState({ FlightData: FlightDataCopy });
    console.log("🚀 3", FlightDataCopy);

    this.props.getAutoSuggestData(
      FlightDataCopy[i][`${type}Value`],
      type == "src" ? "departure" : "return",
      "click"
    );
    FlightDataCopy[i][`show${type}Dropdown`] = true;
    this.setState({ FlightData: FlightDataCopy });
  }

  expandAutoComplete = (bool, type, index) => {
    const FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));
    FlightDataCopy[index][`show${type}Dropdown`] = bool;
    console.log("🚀 2", FlightDataCopy);

    this.setState({ FlightData: FlightDataCopy });
  };

  autoCompleteLeftIcon = () => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="17">
        <path
          fill-rule="evenodd"
          fill="#01445F"
          d="M23.819 6.123 8.442 12.885a1.015 1.015 0 0 1-.331.07.93.93 0 0 1-.474-.152L.924 8.43c-.126-.475-.225-.595-.285-.736-.179-.415.013-.897 1.031-1.076l1.294-.819a.82.82 0 0 1 .682 0L8.414 8.96l4.689-2.67-6.46-3.581a.817.817 0 0 1-.376-.398c.583-.413.004-.897.417-1.08l2.253-.99a.79.79 0 0 1 .589-.029L19.64 3.401l2.327-1.282a2.296 2.296 0 0 1 1.807 0c1.75.676 1.754 3.292.045 4.004zm-.695-2.505a.67.67 0 0 0-.52 0L19.456 5.5c-.191.42.024-.393-.609-.04L9.305 1.857l-.389.443 6.456 3.053a.82.82 0 0 1 .221 1.294.996.996 0 0 1-.266.184L8.72 9.746a.866.866 0 0 1-.266.061c-.14.011-.281-.014.006-.074L3.278 7.441l.052.098 4.875 3.66 14.919-6.587a.54.54 0 0 0 .265-.266c.128.374.009-.601-.265-.728zM1.398 15.35h22.895a.818.818 0 0 1 0 1.637H1.398a.819.819 0 0 1 0-1.637z"
        ></path>
      </svg>
    );
  };

  onClickSetDepartureGoingToValue = (
    city,
    airPortCode,
    airPortName,
    type,
    index
  ) => {
    let FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));
    if (this.state.selectedTripType == "roundTrip") {
      let copyIndex = index == 0 ? 1 : 0;
      let copyType = type == "src" ? "dest" : "src";
      FlightDataCopy[copyIndex][`${copyType}Value`] =
        city + " - (" + airPortCode + ")";
      FlightDataCopy[copyIndex][`${copyType}`] = airPortCode;
    }
    FlightDataCopy[index][`${type}Value`] = city + " - (" + airPortCode + ")";
    FlightDataCopy[index][`${type}`] = airPortCode;
    FlightDataCopy[index][`show${type}Dropdown`] = false;
    console.log("🚀 1", FlightDataCopy);
    if (
      this.state.selectedTripType == "Multicity" &&
      type == "dest" &&
      index < FlightDataCopy.length - 1
    ) {
      FlightDataCopy[index + 1][`srcValue`] = city + " - (" + airPortCode + ")";
      FlightDataCopy[index + 1][`src`] = airPortCode;
    }
    this.setState({ FlightData: FlightDataCopy }, () => {
      console.log(
        "🚀 ~ file: index.js:140 ~ FlightData[index]:",
        this.state.FlightData
      );
      // this.checkValidation(this.state);
    });
  };

  onChangeSetDepartureGoingToValue = (value, type, index) => {
    let FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));
    FlightDataCopy[index][`${type}Value`] = value;
    this.setState({ FlightData: FlightDataCopy }, () => {
      let FlightDataCopy1 = JSON.parse(JSON.stringify(this.state.FlightData));
      this.props.getAutoSuggestData(
        value,
        type == "src" ? "departure" : "return",
        value ? "change" : "click"
      );
      FlightDataCopy1[index][`show${type}Dropdown`] = true;
      console.log("🚀 4", FlightDataCopy1);
      this.setState({ FlightData: FlightDataCopy1 });
    });
  };
  // Autocomplete functions

  // calendar functions
  onChangeDepartureGoingDateValue = (value, type, index) => {
    const FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));
    FlightDataCopy[index][`${type}Date`] = cf.getDateWithFormat(
      value,
      this?.props?.dateFormat
    );
    let dayDifference = differenceInCalendarDays(
      new Date(FlightDataCopy[0][`returnDate`]),
      new Date(value)
    );

    if (
      type == "departure" &&
      dayDifference < 0 &&
      this.state.selectedTripType == "oneWay"
    ) {
      FlightDataCopy[0][`returnDate`] = cf.getDateWithFormat(
        addDays(new Date(value), 7),
        this?.props?.dateFormat
      );
    }
    if (type == "return") {
      let dayDifference = differenceInCalendarDays(
        new Date(FlightDataCopy[index][`returnDate`]),
        new Date(value)
      );
      if (dayDifference < 0)
        FlightDataCopy[index][`returnDate`] = cf.getDateWithFormat(
          addDays(new Date(value), 7),
          this?.props?.dateFormat
        );
    }
    FlightDataCopy[index][`show${type}DateDropdown`] = false;
    if (this.state.selectedTripType == "roundTrip") {
      if (index == 1 && type == "departure")
        FlightDataCopy[0][`returnDate`] = cf.getDateWithFormat(
          value,
          this?.props?.dateFormat
        );

      FlightDataCopy[1][`disabledDate`] = cf.getDateWithFormat(
        new Date(value),
        this?.props?.dateFormat
      );

      let dayDifference = differenceInCalendarDays(
        new Date(FlightDataCopy[0][`returnDate`]),
        new Date(value)
      );
      if (index == 0 && type == "departure" && dayDifference < 0) {
        FlightDataCopy[0][`returnDate`] = cf.getDateWithFormat(
          addDays(new Date(value), 7),
          this?.props?.dateFormat
        );
        FlightDataCopy[1][`departureDate`] = cf.getDateWithFormat(
          addDays(new Date(value), 7),
          this?.props?.dateFormat
        );
      }

      if (index == 0 && type == "return")
        FlightDataCopy[1][`departureDate`] = cf.getDateWithFormat(
          value,
          this?.props?.dateFormat
        );
    }

    if (this.state.selectedTripType == "Multicity") {
      for (let i = index + 1; i < FlightDataCopy.length; i++) {
        let dayDifference = differenceInCalendarDays(
          new Date(FlightDataCopy[i][`departureDate`]),
          new Date(value)
        );
        if (dayDifference < 0)
          FlightDataCopy[i][`departureDate`] = cf.getDateWithFormat(
            addDays(new Date(value), 7),
            this?.props?.dateFormat
          );
        FlightDataCopy[i]["disabledDate"] = cf.getDateWithFormat(
          FlightDataCopy[i - 1][`departureDate`],
          this?.props?.dateFormat
        );
      }
    }
    this.setState({ FlightData: FlightDataCopy });
  };

  calendarSvgIcon = () => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="17">
        <path
          fill-rule="evenodd"
          fill="#01445F"
          d="M23.819 6.123 8.442 12.885a1.015 1.015 0 0 1-.331.07.93.93 0 0 1-.474-.152L.924 8.43c-.126-.475-.225-.595-.285-.736-.179-.415.013-.897 1.031-1.076l1.294-.819a.82.82 0 0 1 .682 0L8.414 8.96l4.689-2.67-6.46-3.581a.817.817 0 0 1-.376-.398c.583-.413.004-.897.417-1.08l2.253-.99a.79.79 0 0 1 .589-.029L19.64 3.401l2.327-1.282a2.296 2.296 0 0 1 1.807 0c1.75.676 1.754 3.292.045 4.004zm-.695-2.505a.67.67 0 0 0-.52 0L19.456 5.5c-.191.42.024-.393-.609-.04L9.305 1.857l-.389.443 6.456 3.053a.82.82 0 0 1 .221 1.294.996.996 0 0 1-.266.184L8.72 9.746a.866.866 0 0 1-.266.061c-.14.011-.281-.014.006-.074L3.278 7.441l.052.098 4.875 3.66 14.919-6.587a.54.54 0 0 0 .265-.266c.128.374.009-.601-.265-.728zM1.398 15.35h22.895a.818.818 0 0 1 0 1.637H1.398a.819.819 0 0 1 0-1.637z"
        ></path>
      </svg>
    );
  };

  onchangeVisibility = (bool, type, index) => {
    const FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));
    FlightDataCopy[index][`show${type}DateDropdown`] = bool;
    this.setState({ FlightData: FlightDataCopy });
    console.log(
      "🚀 ~ file: index.js:368 ~ Theme1 ~ FlightDataCopy:",
      FlightDataCopy
    );
  };

  crossIcon() {
    return (
      <svg
        version="1.1"
        id="Layer_1"
        x="0px"
        y="0px"
        width="30px"
        height="30px"
        viewBox="0 0 30 30"
        enable-background="new 0 0 30 30"
      >
        <g>
          <path
            fill="currentColor"
            d="M15.401,29.146c-7.616,0-13.813-6.196-13.813-13.813S7.785,1.521,15.401,1.521 c7.617,0,13.813,6.196,13.813,13.813S23.018,29.146,15.401,29.146z M15.401,2.521c-7.065,0-12.813,5.747-12.813,12.813 c0,7.064,5.748,12.813,12.813,12.813s12.813-5.748,12.813-12.813C28.214,8.268,22.466,2.521,15.401,2.521z"
          ></path>
        </g>
        <path
          fill="currentColor"
          d="M24.65,15.333c0,0.368-0.299,0.666-0.667,0.666H6.818c-0.368,0-0.667-0.298-0.667-0.666l0,0 c0-0.368,0.298-0.667,0.667-0.667h17.166C24.352,14.666,24.65,14.965,24.65,15.333L24.65,15.333z"
        ></path>
      </svg>
    );
  }

  // calendar functions

  onChangeCabinClassValue = (element, index) => {
    let FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));
    FlightDataCopy[index]["advancesearch"]["cabinclass"] = element;
    FlightDataCopy[index]["advancesearch"]["fcs"] = JSON.parse(
      JSON.stringify(rbdClass)
    );
    FlightDataCopy[index]["advancesearch"]["showCabinClassList"] = false;
    FlightDataCopy = FlightDataCopy.map((el, id) => {
      return {
        ...el,
        advancesearch: {
          ...el?.advancesearch,
          fcs: JSON.parse(JSON.stringify(rbdClass)),
          cabinclass:
            index == id
              ? element
              : el.advancesearch.cabinclass == {}
              ? { label: "Economy", id: 1 }
              : el.advancesearch.cabinclass,
          showCabinClassList:
            index == id ? false : el.advancesearch.showCabinClassList,
        },
      };
    });

    this.setState({ FlightData: FlightDataCopy });
  };

  onClickCabinClass = (index) => {
    console.log("hereee");
    const FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));
    FlightDataCopy[index]["advancesearch"]["showCabinClassList"] =
      !FlightDataCopy[index]["advancesearch"]["showCabinClassList"];
    console.log(
      "🚀 ~ file: index.js:284 ~ Theme1 ~ FlightDataCopy[index]",
      FlightDataCopy[index]["showCabinClassList"]
    );
    this.setState({ FlightData: FlightDataCopy });
  };

  onClickChangePaxNumber = (pax, value, type) => {
    console.log("testtdssffffff", pax, value, type);
    let paxCopy = JSON.parse(JSON.stringify(this.state?.pax));
    if (pax === "adults") {
      if (
        +this.state.pax.child + value <= 9 &&
        +this.state.pax.child + value > 0
      ) {
        paxCopy.adults = value;
        if (type === "minus") {
          if (+this.state.pax.infants > value) {
            paxCopy.infants = +paxCopy.infants;
            --paxCopy.infants;
          }
        }
      }
    } else if (pax === "child") {
      if (
        +value + +this.state.pax.adults <= 9 &&
        +value + +this.state.pax.adults > 0
      )
        paxCopy.child = +value;
    } else if (pax === "infants") {
      if (value > +this.state.pax.adults) paxCopy.infants = +--value;
      else paxCopy.infants = +value;
    }

    console.log("paxCopy", paxCopy);
    this.setState({ pax: paxCopy }, () => {
      console.log("aarti 3", this.state.pax);
    });
  };

  removeList(id) {
    const FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));
    FlightDataCopy.splice(id, 1);
    this.setState({ FlightData: FlightDataCopy }, () => {
      console.log("removeList", this.state.FlightData);
    });
  }

  AddFlightButton = () => {
    const FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));

    let multiObj = {};

    if (FlightDataCopy[FlightDataCopy.length - 1].flight) {
      let previousFlight = FlightDataCopy[FlightDataCopy.length - 1];
      console.log(
        "🚀  file: index.js:353  Theme1 ~ previousFlight:",
        addDays(new Date(previousFlight?.departureDate), 1),
        this.props.dateFormat
      );
      if (FlightDataCopy.length <= 5) {
        multiObj = {
          ...multiObj,
          flight: previousFlight.flight + 1,
          src: previousFlight.dest,
          srcValue: previousFlight.destValue,
          dest: "",
          destValue: "",
          showsrcDropdown: false,
          showdestDropdown: false,
          departureDate: previousFlight.departureDate
            ? format(
                addDays(new Date(previousFlight?.departureDate), 1),
                "dd-MMM-yyyy"
              )
            : "",
          returnDate: previousFlight.returnDate
            ? format(
                addDays(new Date(previousFlight?.returnDate), 7),
                "dd-MMM-yyyy"
              )
            : "",
          showdepartureDateDropdown: false,
          showreturnDateDropdown: false,
          advancesearch: {
            airlines: JSON.parse(JSON.stringify(airline)),
            fcs: JSON.parse(JSON.stringify(rbdClass)),
            dtym: JSON.parse(JSON.stringify(DepartureTime)),
            cabinclass: Object.keys(previousFlight.advancesearch.cabinclass)
              .length
              ? { label: "Economy", id: 1 }
              : {},
            showCabinClassList: false,
          },
          flexiBaggage: true,
          bagreq: true,
          odt: previousFlight.departureDate
            ? format(new Date(previousFlight?.departureDate), "dd-MMM-yyyy")
            : format(Date.now(), this?.props?.dateFormat),
          disabledDate: previousFlight.departureDate
            ? format(new Date(previousFlight?.departureDate), "dd-MMM-yyyy")
            : format(Date.now(), this?.props?.dateFormat),
          error: {
            destErrMsg: "",
            srcErrMsg: "",
          },
        };
        FlightDataCopy.push(multiObj);
        console.log("🚀 ~ file: index.js:570 ~ Theme1 ~ multiObj:", multiObj);
      }
    } else {
      multiObj = {
        ...multiObj,
        flight: 1,
        src: "",
        srcValue: org ? org : "",
        dest: "",
        destValue: "",
        showsrcDropdown: false,
        showdestDropdown: false,
        departureDate: format(new Date(), this?.props?.dateFormat),
        returnDate: format(addDays(new Date(), 7), this?.props?.dateFormat),
        showdepartureDateDropdown: false,
        showreturnDateDropdown: false,
        advancesearch: {
          airlines: JSON.parse(JSON.stringify(airline)),
          fcs: JSON.parse(JSON.stringify(rbdClass)),
          dtym: JSON.parse(JSON.stringify(DepartureTime)),
          cabinclass: { label: "Economy", id: 1 },
          showCabinClassList: false,
        },
        flexiBaggage: true,
        bagreq: true,
        odt: cf.getDateWithFormat(new Date(), this?.props?.dateFormat),
        disabledDate: cf.getDateWithFormat(new Date(), this?.props?.dateFormat),
        error: {
          destErrMsg: "",
          srcErrMsg: "",
        },
      };
      FlightDataCopy.push(multiObj);
    }

    console.log(
      "🚀  file: index.js:540  Theme1  this.setState  FlightDataCopy13:",
      FlightDataCopy
    );

    this.setState({ FlightData: FlightDataCopy }, () => {
      console.log(
        "🚀  file: index.js:534  Theme1  this.setState  FlightData:",
        this.state.FlightData
      );
    });
  };

  //Add client
  adGuestId = (id) => {
    this.setState({ guest_id: id }, () => {
      if (this.state.isError.selectedGuest === true) {
        this.validateErrorMsg();
      }
      this.setState({ guest_id: id });
    });
  };

  rmGuestId = () => {
    this.setState({ guest_id: "" });
  };

  handleClickOutside = () => {
    const FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));

    if (this.state.openCabinClassList === true)
      this.setState({ openCabinClassList: false });
    if (this.state.expandDepartureBoolean === true)
      this.setState({ expandDepartureBoolean: false });
    if (this.state.expandGoingToBoolean === true)
      this.setState({ expandGoingToBoolean: false });
    if (
      this.guestDetailWrapper.current &&
      !this.guestDetailWrapper.current.contains(event.target)
    ) {
      this.setState({ openTraveler: false });
    }
    if (
      this.passengerDropdownWrapper.current &&
      !this.passengerDropdownWrapper.current.contains(event.target)
    ) {
      this.setState({ showTraveller: false });
    }

    if (
      this.travellerCabin.current &&
      !this.travellerCabin.current.contains(event.target)
    ) {
      this.setState({ travellerCabin: false });
    }

    if (
      this.departureListWrapper.current &&
      !this.departureListWrapper.current.contains(event.target)
    ) {
      console.log("dgfdghhfgh11111", this.departureListWrapper.current);
      let index = this.departureListWrapper.current.id
        ? this.departureListWrapper.current.id.split("_")[2]
        : "";
      console.log("frfrbf", FlightDataCopy, index);

      FlightDataCopy[index]["showsrcDropdown"] = false;
      console.log("frfrf", FlightDataCopy, index);
    }

    if (
      this.returnListWrapper.current &&
      !this.returnListWrapper.current.contains(event.target)
    ) {
      console.log("dgfdghhfgh", this.returnListWrapper.current);

      let index = this.returnListWrapper.current.id
        ? this.returnListWrapper.current.id.split("_")[2]
        : "";

      FlightDataCopy[index]["showdestDropdown"] = false;
      console.log("frfrf", FlightDataCopy, index);
    }
    if (
      this.economyPopUpWrapper.current &&
      this.economyPopUpWrapper.current.length
    ) {
      this.economyPopUpWrapper.current.forEach((wrapper) => {
        if (!wrapper?.contains(event.target)) {
          let index = wrapper?.id ? parseInt(wrapper.id.split("_")[2]) : 0;
          FlightDataCopy[index]["advancesearch"]["showCabinClassList"] = false;
        }
      });
    }

    this.setState({ FlightData: FlightDataCopy });
  };
  onClickOpenCabinClassList = () => {
    // document.getElementById("modal_container-popup").scrollIntoView({ behavior: 'smooth', block: 'start' })
    if (this.state.openCabinClassList === false) {
      this.setState({ openCabinClassList: true });
    } else if (this.state.openCabinClassList === true) {
      this.setState({ openCabinClassList: false });
    }
  };

  checkValidation = (item) => {
    let isValid = true;
    const { FlightData = [] } = item;
    FlightData.forEach((data, index) => {
      console.log(
        "🚀 ~ file: index.js:456 ~ Theme1 ~ FlightData.forEach ~ data:",
        data
      );
      let errorObj = data.error || {};
      if (data["srcValue"] === "") {
        isValid = false;
        errorObj["srcErrMsg"] = "Enter Origin City";
      }
      if (data["destValue"] === "") {
        isValid = false;
        errorObj["destErrMsg"] = "Enter Destination City";
      }

      if (data["srcValue"] === data["destValue"] && data["destValue"] !== "") {
        isValid = false;
        errorObj["destErrMsg"] = "Origin and destination cannot be same";
      }
      if (this.state.selectedTripType == "roundTrip") {
        if (
          index !== FlightData.length - 1 &&
          data["srcValue"] === FlightData[index + 1]["srcValue"] &&
          data["destValue"] === FlightData[index + 1]["destValue"]
        ) {
          isValid = false;
          errorObj["destErrMsg"] = "Origin and destination cannot be same";
          FlightData[index + 1].error.destErrMsg =
            "Origin and destination cannot be same";
        }
      }
      if (
        !data["advancesearch"]["fcs"].some((el) => el.isChecked) &&
        Object.keys(data["advancesearch"]["cabinclass"]).length === 0
      ) {
        isValid = false;
        errorObj["rbdCabinErrMsg"] = "Please Select RBD/ Cabin";
      }

      data.error = errorObj;
    });
    return { isValid, data: FlightData };
  };

  getSector = (data) => {
    let resp = data.map((element) => {
      console.log("datee aarti", element);
      let srcValue = element?.srcValue.split("-");
      console.log("srghgcValue", srcValue, srcValue[0].trim());

      let destValue = element?.destValue.split("-");

      return {
        from: element?.src,
        to: element?.dest,
        fromcity: srcValue[0].trim(),
        tocity: destValue[0].trim(),
        date: format(new Date(element?.departureDate), "yyyy-MM-dd"),
        cabin: element.advancesearch?.cabinclass
          ? `${element.advancesearch?.cabinclass}`
          : 0,
        rbd: element.advancesearch?.fcs,
        airlines: element.advancesearch?.airlines,
        departuretime: element.advancesearch.dtym,
        flexibag: element.advancesearch.bagreq === true ? "1" : "0",
      };
    });
    console.log("gdataaaa", resp);

    return resp;
  };

  onClickSearchFlight = () => {
    let { isValid, data } = this.checkValidation(this.state);
    console.log(
      "🚀 ~ file: index.js:550 ~ Theme1 ~ isValid:",
      isValid,
      this.state.FlightData
    );

    if (isValid) {
      let updatedFlightData = this.state.FlightData.map((flightObj) => {
        console.log(
          "🚀 ~ file: index.js:623 ~ Theme1 ~ updatedFlightData ~ flightObj:",
          flightObj
        );

        return {
          ...flightObj,
          advancesearch: {
            airlines:
              flightObj.advancesearch.airlines &&
              flightObj.advancesearch.airlines
                .filter((option) => option.isChecked)
                .map((item) => item.value),
            fcs:
              flightObj.advancesearch.fcs &&
              flightObj.advancesearch.fcs
                .filter((option) => option.isChecked)
                .map((item) => item.value),
            dtym: flightObj.advancesearch.dtym
              .filter((option) => option.isChecked)
              .map((item) => item.code),
            cabinclass: this.state.isAdvanceSearch
              ? flightObj?.advancesearch?.cabinclass?.id
              : this.state.travellerCabinClass.id,
          },
        };
      });

      let sectorRequest = this.getSector(updatedFlightData);
      console.log("gdataaaa", sectorRequest);

      let sector = getUrl(sectorRequest);
      let urseurl = parseurl(sector);

      console.log("temp", sector);

      console.log("urseurl", urseurl);
      let pax = Object.values(this.state.pax).map((value) => value);

      pax = pax.join("_");
      console.log("chgfjfgj", pax);
      let supplier = this.props.selectedSupplier
        ? this.props.selectedSupplier
            .filter((option) => option.isChecked)
            .map((item) => item.value)
            .join("~")
        : [];

      let trip = TripType.find(
        (ele) => ele.value == this.state.selectedTripType
      );
      let splfare = this.props.FareType
        ? this.props.FareType.filter((option) => option.isChecked).map(
            (item) => item.code
          )
        : "";

      let urlQuery = {
        sector: sector,
        pax: pax,
        supplier: supplier,
        splfare: splfare,
        type: trip.id,
        isAdvanceSearch: this.state.isAdvanceSearch,
        guests: this.state.guest_id,
      };
      console.log("🚀 ~ file: index.js:581 ~ Theme1 ~ urlQuery:", urlQuery);

      if (!this.props.isOffline) {
        cf.redirectTo("flight/search", urlQuery);
      } else {
        cf.redirectTo("/offlinesearch/flight", urlQuery);
      }
    } else {
      this.setState({ FlightData: data }, () => {
        console.log("aksjyyyy", this.state.FlightData);
      });
    }
  };

  validateErrorMsg = () => {
    const mapDispatch = {
      departure: commonFunction.isValueEmpty(this.state.departureValue)
        ? true
        : false,
      goingTo: commonFunction.isValueEmpty(this.state.goingToValue)
        ? true
        : false,
      departureDate: commonFunction.isValueEmpty(this.state.departureDateValue)
        ? true
        : false,
      goingToDate: commonFunction.isValueEmpty(this.state.goingToDateValue)
        ? true
        : false,
      selectedGuest: cf.isValueEmpty(this.state.guest_id) ? true : false,
    };
    this.setState({ isError: mapDispatch });
  };

  onClickSwap = (index) => {
    console.log(
      "🚀 ~ file: index.js:823 ~ Theme1 ~ index:",
      index,
      this.state.FlightData
    );
    const FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));
    const FlightDataCopy1 = JSON.parse(JSON.stringify(this.state.FlightData));

    FlightDataCopy[index]["src"] = FlightDataCopy1[index]["dest"];
    FlightDataCopy[index]["srcValue"] = FlightDataCopy1[index]["destValue"];
    FlightDataCopy[index]["dest"] = FlightDataCopy1[index]["src"];
    FlightDataCopy[index]["destValue"] = FlightDataCopy1[index]["srcValue"];

    if (
      !this.state.isAdvanceSearch &&
      this.state.selectedTripType == "roundTrip"
    ) {
      FlightDataCopy[index + 1]["src"] = FlightDataCopy1[index + 1]["dest"];
      FlightDataCopy[index + 1]["srcValue"] =
        FlightDataCopy1[index + 1]["destValue"];
      FlightDataCopy[index + 1]["dest"] = FlightDataCopy1[index + 1]["src"];
      FlightDataCopy[index + 1]["destValue"] =
        FlightDataCopy1[index + 1]["srcValue"];
    }
    this.setState({ FlightData: FlightDataCopy }, () => {
      console.log(
        "🚀 ~ file: index.js:833 ~ Theme1 ~ this.setState ~ FlightData:",
        this.state.FlightData
      );
    });
  };

  onClickOpenPassangerList = () => {
    this.setState({ travellerCabin: !this.state.travellerCabin });
  };

  onClickAirlines = () => {
    this.setState({ isAdvanceSearch: !this.state.isAdvanceSearch });
  };

  onselectTrip = (trip) => {
    const FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));
    let flightArr = [];
    let flightObj = { ...FlightDataCopy[0] };
    let flightObjCopy = { ...FlightDataCopy[0] };

    if (trip.value == "roundTrip") {
      flightArr.push({ ...flightObj });
      flightArr.push({
        ...flightObj,
        dest: flightObjCopy.src,
        destValue: flightObjCopy.srcValue,
        srcValue: flightObjCopy.destValue,
        src: flightObjCopy.dest,
        departureDate: flightObjCopy.returnDate,
        returnDate: addDays(new Date(flightObjCopy.departureDate), 7),
        flight: flightObj.flight + 1,
        disabledDate: flightArr[0].departureDate,
      });
      console.log("🚀  file: index.js:828  Theme1 ~ flightArr:", flightArr);
    } else if (trip.value == "oneWay") {
      flightArr.push({ ...flightObj });
    } else {
      flightArr.push({ ...flightObj });
      flightArr.push({
        ...flightObj,
        disabledDate: flightArr[0].departureDate,
      });
    }

    this.setState({ FlightData: flightArr });

    this.setState({
      selectedTripType: trip.value,
    });
  };

  traveller = () => {
    return (
      <div
        className={`${this.props.styles.advn_box} ${this.props.styles.mrgn_top}`}
      >
        <div
          className={this.props.styles.advLbl}
          onClick={() => {
            this.setState({ showTraveller: !this.state.showTraveller });
          }}
        >
          <label>Traveller</label>
          <div className={this.props.styles.travMn_flx}>
            <div className={this.props.styles.inner_rbdIcon}>
              <svg width="20px" height="20px" viewBox="0 0 200 200">
                <g>
                  <path
                    fill="#01445f"
                    d="M100,188.716c-48.918,0-88.716-39.798-88.716-88.716S51.082,11.284,100,11.284S188.716,51.082,188.716,100 S148.918,188.716,100,188.716z M45.883,162.507c14.516,12.586,33.442,20.209,54.117,20.209c20.675,0,39.602-7.624,54.118-20.209 c-1.134-27.888-38.089-30.935-54.118-30.935S47.016,134.62,45.883,162.507z M100,17.284c-45.61,0-82.716,37.106-82.716,82.716 c0,22.237,8.82,42.452,23.146,57.331c1.983-10.823,9.079-19.279,20.815-24.682c12.708-5.85,28.09-7.077,38.755-7.077 c10.666,0,26.048,1.228,38.756,7.077c11.736,5.402,18.832,13.858,20.814,24.682c14.326-14.88,23.146-35.094,23.146-57.331 C182.716,54.39,145.609,17.284,100,17.284z M100,103c-17.409,0-31.572-14.163-31.572-31.572c0-17.409,14.163-31.572,31.572-31.572 c17.409,0,31.572,14.163,31.572,31.572C131.572,88.837,117.409,103,100,103z M100,45.856c-14.1,0-25.572,11.472-25.572,25.572 C74.428,85.528,85.9,97,100,97c14.101,0,25.572-11.472,25.572-25.572C125.572,57.328,114.101,45.856,100,45.856z"
                  ></path>
                </g>
              </svg>
            </div>
            <div className={this.props.styles.inner_passng}>
              {`${
                +this.state.pax.adults +
                +this.state.pax.child +
                +this.state.pax.infants
              }`}
              &nbsp;Passenger
            </div>
          </div>
        </div>
        {this.state.showTraveller === true ? (
          <div
            className={this.props.styles.flighttraveller_drop}
            ref={this.passengerDropdownWrapper}
          >
            <div className={this.props.styles.flighttraveller_drop_flex}>
              <div className={this.props.styles.flighttraveller_drop_adult}>
                <label>Adult</label>
                <span>(+12 Years)</span>
              </div>
              <PaxConfig
                value={
                  !cf.isValueEmpty(this.state.pax.adults)
                    ? +this.state.pax.adults
                    : 0
                }
                onChangePaxValue={(value, type) =>
                  this.onClickChangePaxNumber("adults", value, type)
                }
                maxLimit={9}
                minLimit={1}
                totalPax={+this.state.pax.child + +this.state.pax.adults}
                styles={this.props.styles}
              />
            </div>

            <div className={this.props.styles.flighttraveller_drop_flex}>
              <div className={this.props.styles.flighttraveller_drop_adult}>
                <label>Children</label>
                <span>(2-11 Years)</span>
              </div>
              <PaxConfig
                value={
                  !cf.isValueEmpty(this.state.pax.child)
                    ? +this.state.pax.child
                    : 0
                }
                onChangePaxValue={(value, type) =>
                  this.onClickChangePaxNumber("child", value, type)
                }
                maxLimit={9}
                minLimit={0}
                totalPax={+this.state.pax.child + +this.state.pax.adults}
                styles={this.props.styles}
              />
            </div>

            <div className={this.props.styles.flighttraveller_drop_flex}>
              <div className={this.props.styles.flighttraveller_drop_adult}>
                <label>Infant</label>
                <span>(Below 2 Years)</span>
              </div>
              <PaxConfig
                value={
                  !cf.isValueEmpty(this.state.pax.infants)
                    ? +this.state.pax.infants
                    : 0
                }
                onChangePaxValue={(value, type) =>
                  this.onClickChangePaxNumber("infants", value, type)
                }
                maxLimit={+this.state.pax.adults}
                minLimit={0}
                totalPax={+this.state.pax.infants}
                styles={this.props.styles}
              />
            </div>
          </div>
        ) : null}
      </div>
    );
  };

  cabinClassEle = (ele, id) => {
    console.log("ele.cabinclass", ele.advancesearch.cabinclass);
    return (
      <div
        className={this.props.styles.advn_box}
        ref={(el) => {
          if (!this.economyPopUpWrapper.current)
            this.economyPopUpWrapper.current = [];
          return (this.economyPopUpWrapper.current[id] = el);
        }}
        id={`Flight_cabin_${parseInt(id)}`}
      >
        <div className={""}>
          <label>Cabin</label>
          <div className={this.props.styles.cabin_mFlx}>
            <div className={""}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18">
                <path
                  fill-rule="evenodd"
                  fill="#005A95"
                  d="M12.767 15.73h-1.771v.523a1.18 1.18 0 0 1-1.18 1.181H.962v-1.181h8.854v-.523H4.785c-.534 0-1.002-1.016-1.14-1.532L1.43 4.471c-.724-1.259.023-2.554 1.283-2.891a2.36 2.36 0 0 1 2.891 1.669l1.9 7.103h5.158a2.432 2.432 0 0 1 2.454 2.124c.008.077.011.154.011.231.002 1.413-.407 3.003-2.36 3.023zm0-4.198h-6.17L4.464 3.555c-.169-.63-.816-1.004-1.284-.835-.792.169-1.04.816-.997 1.446l2.602 9.727h7.982a1.18 1.18 0 0 0 1.18-1.181c0-.102-.528-1.18-1.18-1.18zm.59-3.541a.885.885 0 1 1 0-1.77.885.885 0 0 1 0 1.77zm-.59-7.082h1.18V5.4h-1.18V.909z"
                />
              </svg>
            </div>
            <div
              className={this.props.styles.adv_Cabinflx}
              onClick={() => {
                this.onClickCabinClass(id);
              }}
            >
              <div className={this.props.styles.adv_CabinLable}>
                {!cf.isValueEmpty(ele.advancesearch.cabinclass)
                  ? ele.advancesearch.cabinclass.label
                  : ""}
              </div>
              <div className={""}>
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="8">
                  <path
                    fill-rule="evenodd"
                    fill="#01445F"
                    d="M11.606.458c.704-.008 1.103.082 1.515.021a1.073 1.073 0 0 1-.021 1.517L7.746 7.198l-.747-.769.748.772a1.072 1.072 0 0 1-1.554-.061L.942 1.996A1.074 1.074 0 0 1 .921.479C1.334.54 2.12.45 2.437.458L7.2 4.931 11.606.458z"
                  />
                </svg>
              </div>
            </div>
          </div>
          {ele.advancesearch.showCabinClassList ? (
            <div className={this.props.styles.flight_cabin_class_list}>
              {cabinClass.map((element, index) => {
                return (
                  <div className={this.props?.styles?.flight_cabin_bxd}>
                    <label
                      key={"cabinClass" + index}
                      className={this.props?.styles?.pax_input}
                      onClick={() => {
                        this.onChangeCabinClassValue(element, id);
                      }}
                    >
                      <input
                        type="radio"
                        checked={
                          element.label === ele.advancesearch?.cabinclass?.label
                        }
                      />
                      <span className={this.props.styles.classTitle}>
                        {element.label}
                      </span>
                    </label>
                  </div>
                );
              })}
            </div>
          ) : null}
        </div>
        {ele.error.rbdCabinErrMsg ? (
          <span className={this.props.styles.rbderr}>
            {ele.error.rbdCabinErrMsg}
          </span>
        ) : null}
      </div>
    );
  };

  travellerCabinEle = () => {
    console.log(
      "vbvbbvbcc",
      +this.state.pax.adults + +this.state.pax.child + +this.state.pax.infants,
      this.state.travellerCabinClass.label
    );

    return (
      <>
        <div
          className={
            this.props.styles.mob_flight_search_column +
            " " +
            this.props.styles.mob_flight_search_pax
          }
          onClick={() => this.onClickOpenPassangerList()}
        >
          <div className={this.props.styles.flight_trav_title}>
            {" "}
            Traveler | Class
          </div>
          <div className={this.props.styles.flight_cabin_class_name}>
            <span>
              <svg width="20px" height="20px" viewBox="0 0 200 200">
                <g>
                  <path
                    fill="#30C8CA"
                    d="M100,188.716c-48.918,0-88.716-39.798-88.716-88.716S51.082,11.284,100,11.284S188.716,51.082,188.716,100 S148.918,188.716,100,188.716z M45.883,162.507c14.516,12.586,33.442,20.209,54.117,20.209c20.675,0,39.602-7.624,54.118-20.209 c-1.134-27.888-38.089-30.935-54.118-30.935S47.016,134.62,45.883,162.507z M100,17.284c-45.61,0-82.716,37.106-82.716,82.716 c0,22.237,8.82,42.452,23.146,57.331c1.983-10.823,9.079-19.279,20.815-24.682c12.708-5.85,28.09-7.077,38.755-7.077 c10.666,0,26.048,1.228,38.756,7.077c11.736,5.402,18.832,13.858,20.814,24.682c14.326-14.88,23.146-35.094,23.146-57.331 C182.716,54.39,145.609,17.284,100,17.284z M100,103c-17.409,0-31.572-14.163-31.572-31.572c0-17.409,14.163-31.572,31.572-31.572 c17.409,0,31.572,14.163,31.572,31.572C131.572,88.837,117.409,103,100,103z M100,45.856c-14.1,0-25.572,11.472-25.572,25.572 C74.428,85.528,85.9,97,100,97c14.101,0,25.572-11.472,25.572-25.572C125.572,57.328,114.101,45.856,100,45.856z"
                  ></path>
                </g>
              </svg>
            </span>
            {`${
              +this.state.pax.adults +
              +this.state.pax.child +
              +this.state.pax.infants
            } Passenger, ${this.state.travellerCabinClass.label}`}
          </div>

          <div
            className={this.props.styles.flight_cabin_class_arrow_pass}
          ></div>
        </div>

        {this.state.travellerCabin ? (
          <div
            className={this.props.styles.flighttraveller_dropNorm}
            ref={this.travellerCabin}
          >
            <div className={this.props.styles.flighttraveller_drop_flex}>
              <div className={this.props.styles.flighttraveller_drop_adult}>
                <label>Adult(s)</label>
                <span>(12 yrs & above)</span>
              </div>
              <PaxConfig
                value={
                  !cf.isValueEmpty(this.state.pax.adults)
                    ? +this.state.pax.adults
                    : 0
                }
                onChangePaxValue={(value, type) =>
                  this.onClickChangePaxNumber("adults", value, type)
                }
                maxLimit={9}
                minLimit={1}
                totalPax={+this.state.pax.child + +this.state.pax.adults}
                styles={this.props.styles}
              />
            </div>

            <div className={this.props.styles.flighttraveller_drop_flex}>
              <div className={this.props.styles.flighttraveller_drop_adult}>
                <label>Children(s)</label>
                <span>(2-12 yrs)</span>
              </div>
              <PaxConfig
                value={
                  !cf.isValueEmpty(this.state.pax.child)
                    ? +this.state.pax.child
                    : 0
                }
                onChangePaxValue={(value, type) =>
                  this.onClickChangePaxNumber("child", value, type)
                }
                maxLimit={9}
                minLimit={0}
                totalPax={+this.state.pax.child + +this.state.pax.adults}
                styles={this.props.styles}
              />
            </div>

            <div className={this.props.styles.flighttraveller_drop_flex}>
              <div className={this.props.styles.flighttraveller_drop_adult}>
                <label>Infant(s)</label>
                <span>(below 2 yrs)</span>
              </div>
              <PaxConfig
                value={
                  !cf.isValueEmpty(this.state.pax.infants)
                    ? +this.state.pax.infants
                    : 0
                }
                onChangePaxValue={(value, type) =>
                  this.onClickChangePaxNumber("infants", value, type)
                }
                maxLimit={+this.state.pax.adults}
                minLimit={0}
                totalPax={this.state.pax.infants}
                styles={this.props.styles}
              />
            </div>

            <div
              className={`${this.props?.styles?.flight_pax_title} ${this.props?.styles?.cabin_class_sec}`}
            >
              Cabin Class
            </div>
            {
              <div
                // ref={this.economyPopUpWrapper}
                className={this.props?.styles?.flight_cabin_class_list_them}
              >
                {cabinClass.map((element, index) => {
                  return (
                    <div className={this.props?.styles?.flight_cabin_bxd}>
                      <input
                        type="radio"
                        className={this.props?.styles?.pax_input}
                        checked={
                          element.label === this.state.travellerCabinClass.label
                        }
                        onClick={() => {
                          this.setState({
                            travellerCabinClass: element,
                          });
                        }}
                        id={element.label}
                        value={element.label}
                      />
                      <label>{element.label} </label>
                    </div>
                  );
                })}
              </div>
            }

            <div className={this.props.styles.pax_btn_thme}>
              <button
                onClick={() => {
                  this.onClickOpenPassangerList();
                }}
              >
                {" "}
                Done
              </button>
            </div>
          </div>
        ) : null}
      </>
    );
  };

  RBDClassDropdown = (index) => {
    const { FlightData } = this.state;
    const options = FlightData[index]?.advancesearch?.fcs;
    console.log("🚀 ~ file: index.js:830 ~ options:", options);

    return (
      <MultiSelectDropDown
        style={this.props.multiselectMobile}
        inputPlaceHolder={"Select RBD Class"}
        dropdownInputPlaceHolder={"Type here RBD"}
        options={options}
        setoptions={(newOptions) => {
          let updatedData = JSON.parse(JSON.stringify(FlightData));
          // updatedData[index] = {
          //   ...updatedData[index],
          //   advancesearch: {
          //     ...updatedData[index]?.advancesearch,
          //     fcs: newOptions,
          //     cabinclass: newOptions.some((opt) => opt.isChecked) ? {} : { label: "Economy", id: 1 }
          //   },
          // };

          updatedData = updatedData.map((el, id) => {
            return {
              ...el,
              advancesearch: {
                ...el?.advancesearch,
                fcs: index == id ? newOptions : el.advancesearch.fcs,
                cabinclass: {},
              },
            };
          });
          this.setState({ FlightData: updatedData });
        }}
      />
    );
  };

  AirlineClassDropdown = (index) => {
    const { FlightData } = this.state;
    const options = FlightData[index]?.advancesearch?.airlines;

    return (
      <MultiSelectDropDown
        style={this.props.multiselectMobile}
        inputPlaceHolder={"Select Airline"}
        dropdownInputPlaceHolder={"Type here Airline"}
        options={options}
        setoptions={(newOptions) => {
          const updatedData = JSON.parse(JSON.stringify(FlightData));
          updatedData[index] = {
            ...updatedData[index],
            advancesearch: {
              ...updatedData[index]?.advancesearch,
              airlines: newOptions,
            },
          };
          this.setState({ FlightData: updatedData });
        }}
      />
    );
  };
  onClickTraveller = () => {
    if (!this.state.openTraveler) {
      this.setState({ openTraveler: true });
    } else {
      this.setState({ openTraveler: false });
    }
  };
  DepartureTimeDropdown = (index) => {
    const { FlightData } = this.state;
    let departureOption = FlightData[index]?.advancesearch?.dtym;
    return (
      <MultiSuppilerDropDownoption
        options={departureOption}
        setoptions={(newOptions) => {
          const updatedData = JSON.parse(JSON.stringify(FlightData));
          updatedData[index] = {
            ...updatedData[index],
            advancesearch: {
              ...updatedData[index]?.advancesearch,
              dtym: newOptions,
            },
          };
          this.setState({ FlightData: updatedData });
        }}
        inputPlaceHolder={"Departure Time"}
        style={this.props.styleMobile}
        box={this.box}
      />
    );
  };

  render = () => {
    return (
      <div className={this.props.styles.mob_flight_search_wid_container}>
        <div className={this.props.styles.mob_flight_search_wid_main}>
          <div id={this.props.styles.tab_submenu_content}>
            <div
              className={
                this.props.styles.landing_tab_submenu_new +
                " " +
                this.props.styles.sub_tab_new
              }
            >
              <div className={this.props.styles.mobile_visible}>
                <div
                  className={
                    this.props.styles.mobo_tab_header +
                    " " +
                    this.props.styles.flight_header_mobo
                  }
                >
                  {/* <img src="/images/back-arrow.png" alt="" className={this.props.styles.arrow_image} onClick={() => this.props.onClosePopup(false)} /> */}
                  <span
                    className={this.props.styles.arrow_image}
                    onClick={() => this.props.onClosePopup(false)}
                  >
                    {/* <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                                        </svg> */}
                    <svg
                      version="1.1"
                      id="Layer_1"
                      x="0px"
                      y="0px"
                      width="200px"
                      height="200px"
                      viewBox="0 0 200 200"
                      stroke="currentColor"
                    >
                      <g>
                        <g>
                          <path
                            fill="currentColor"
                            d="M94.277,181.169c-3.199,0-6.398-1.22-8.839-3.661L16.77,108.839c-4.881-4.882-4.881-12.796,0-17.678    l68.668-68.668c4.882-4.882,12.797-4.882,17.678,0c4.882,4.881,4.882,12.796,0,17.678L43.287,100l59.83,59.83    c4.882,4.882,4.882,12.796,0,17.678C100.676,179.948,97.476,181.169,94.277,181.169z"
                          ></path>
                        </g>
                        <g>
                          <path
                            fill="currentColor"
                            d="M174.391,112.5H35.146c-6.903,0-12.5-5.597-12.5-12.5s5.597-12.5,12.5-12.5h139.245    c6.903,0,12.5,5.597,12.5,12.5S181.294,112.5,174.391,112.5z"
                          ></path>
                        </g>
                      </g>
                    </svg>
                  </span>
                  <h3 className={this.props.styles.search_filter_header}>
                    Flights
                  </h3>
                </div>
              </div>
            </div>
          </div>

          <div className={this.props.styles.search_popup}>
            {/* flight tabs */}

            <div className={this.props.styles.mob_flight_way_tab}>
              <div className={this.props.styles.mob_flight_way_btngrp}>
                {TripType.map((trip, id) => {
                  return (
                    <button
                      className={
                        trip.value === this.state.selectedTripType
                          ? this.props.styles.active_way
                          : this.props.styles.button_style
                      }
                      onClick={() => {
                        this.onselectTrip(trip);
                      }}
                    >
                      <input
                        id={`flight_${trip.value}` || "trip_type"}
                        type="radio"
                        value={trip.value}
                        checked={trip.value === this.state.selectedTripType}
                      />
                      <label>{trip.label}</label>
                    </button>
                  );
                })}
              </div>
            </div>
            {/* flight tabs end */}

            {/* b2b flow adanvance search */}
            {this.props?.userProfile?.userType === "B2B" && (
              <B2BWidgets
                theme="theme4"
                isMobile={true}
                type="flight"
                styles={this.props.styles1}
                {...this.state}
                onClickAirlines={this.onClickAirlines}
                listWrapper={this.advanceSearchWrapper}
                guestWrapper={this.guestDetailWrapper}
                isOffline={this.props.isOffline}
                errorMessage={"Select Traveler"}
                openAirlines={this.state.isAdvanceSearch}
                onClickTraveller={this.onClickTraveller}
                applyb2bFilters={this.applyb2bFilters}
                addGuestId={this.adGuestId}
                removeGuestId={this.rmGuestId}
                handleOnChangeAirlines={this.handleOnChangeAirlines}
                handleStopCheck={this.handleStopCheck}
                isError={this.state.isError.selectedGuest}
                isSRP={this.props.isSRP || false}
              />
            )}
            {/* b2b flow adanvance search end */}

            <div
              id="modal_container-popup"
              className={this.props.styles.mob_flight_search_details_container}
            >
              {/* main content */}

              <div className={this.props.styles.mob_flight_search_details_main}>
                {this.state.FlightData &&
                  this.state.FlightData.map((ele, id) => {
                    console.log("🚀 ~ ele:", ele, id, ele.error.srcErrMsg);
                    if (
                      this.state.selectedTripType === "roundTrip" &&
                      id == 1 &&
                      this.state.isAdvanceSearch === false
                    ) {
                      return <></>;
                    }
                    return (
                      <>
                        <div
                          className={
                            this.props.styles.mob_flight_search_details_row
                          }
                        >
                          <div
                            className={
                              this.props.styles.mob_flight_search_column +
                              " " +
                              this.props.styles.mob_flight_search_depart
                            }
                          >
                            <FlightAutoComplete
                              label="From"
                              id="flight_search_from"
                              value={ele.srcValue}
                              onclickFlightAutoComplete={() =>
                                this.onclickFlightAutoComplete("src", id)
                              }
                              styles={this.props.styles}
                              state={this.state}
                              placholder="Where are you going?"
                              onClickSourceAndDestination={(
                                airPortCode,
                                city,
                                airPortName
                              ) =>
                                this.onClickSetDepartureGoingToValue(
                                  airPortCode,
                                  city,
                                  airPortName,
                                  "src",
                                  id
                                )
                              }
                              onChangeSourceAndDestination={(value) =>
                                this.onChangeSetDepartureGoingToValue(
                                  value,
                                  "src",
                                  id
                                )
                              }
                              isAutoCompleteExpand={(bool) => {
                                this.expandAutoComplete(bool, "src", id);
                              }}
                              autoCompleteData={
                                this.props.getDepartureSuggestionList || []
                              }
                              expandAutoCompleteBool={
                                ele.showsrcDropdown || false
                              }
                              leftIcon={
                                <svg width="26" height="17">
                                  <path
                                    fill-rule="evenodd"
                                    fill="#01445F"
                                    d="M23.819 6.123 8.442 12.885a1.015 1.015 0 0 1-.331.07.93.93 0 0 1-.474-.152L.924 8.43c-.126-.475-.225-.595-.285-.736-.179-.415.013-.897 1.031-1.076l1.294-.819a.82.82 0 0 1 .682 0L8.414 8.96l4.689-2.67-6.46-3.581a.817.817 0 0 1-.376-.398c.583-.413.004-.897.417-1.08l2.253-.99a.79.79 0 0 1 .589-.029L19.64 3.401l2.327-1.282a2.296 2.296 0 0 1 1.807 0c1.75.676 1.754 3.292.045 4.004zm-.695-2.505a.67.67 0 0 0-.52 0L19.456 5.5c-.191.42.024-.393-.609-.04L9.305 1.857l-.389.443 6.456 3.053a.82.82 0 0 1 .221 1.294.996.996 0 0 1-.266.184L8.72 9.746a.866.866 0 0 1-.266.061c-.14.011-.281-.014.006-.074L3.278 7.441l.052.098 4.875 3.66 14.919-6.587a.54.54 0 0 0 .265-.266c.128.374.009-.601-.265-.728zM1.398 15.35h22.895a.818.818 0 0 1 0 1.637H1.398a.819.819 0 0 1 0-1.637z"
                                  ></path>
                                </svg>
                              }
                              errorMessage={ele.error.srcErrMsg}
                              isError={ele.error.srcErrMsg ? true : false}
                              listWrapper={this.departureListWrapper}
                            />
                          </div>
                          <div
                            className={this.props.styles.mob_flight_swap_main}
                            onClick={() => {
                              this.onClickSwap(id);
                            }}
                          >
                            <img
                              src="/theme4/swipeT.svg"
                              className={this.props.styles.mob_flight_swap}
                              alt="flight arrow"
                              value="Swap"
                            ></img>
                          </div>
                          <div
                            className={
                              this.props.styles.mob_flight_search_column +
                              " " +
                              this.props.styles.mob_flight_search_depart
                            }
                          >
                            <FlightAutoComplete
                              label="To"
                              id="flight_search_to"
                              value={ele.destValue}
                              onclickFlightAutoComplete={() =>
                                this.onclickFlightAutoComplete("dest", id)
                              }
                              styles={this.props.styles}
                              state={this.state}
                              placholder="Where are you going?"
                              onClickSourceAndDestination={(
                                city,
                                airPortCode,
                                airPortName
                              ) =>
                                this.onClickSetDepartureGoingToValue(
                                  city,
                                  airPortCode,
                                  airPortName,
                                  "dest",
                                  id
                                )
                              }
                              listWrapper={this.returnListWrapper}
                              isAutoCompleteExpand={(bool) => {
                                this.expandAutoComplete(bool, "dest", id);
                              }}
                              autoCompleteData={
                                this.props.getGoingToSuggestionList || []
                              }
                              expandAutoCompleteBool={
                                ele.showdestDropdown || false
                              }
                              leftIcon={
                                <svg width="26" height="19">
                                  <path
                                    fill-rule="evenodd"
                                    fill="#01445F"
                                    d="M24.293 18.987H1.398a.819.819 0 0 1 0-1.637h22.895a.818.818 0 0 1 0 1.637zm-2.001-4.807L5.715 11.466a1.031 1.031 0 0 1-.316-.122c-.137-.098-.246-.231.441-.386L2.52 3.307c-.526-.141-.543-.197-.22-.447.5-.446.203-.745.649-.669l2.036.348a.823.823 0 0 1 .573.372l2.744 4.524 5.058.824-3.605-6.305a.819.819 0 0 1 .84-1.216l2.635.397c-.005.03.177.137.302.297l6.258 7.874 3.132.508c.619.107 1.958.463 1.515.985 1.099 1.521-.324 3.716-2.145 3.381zm1.458-2.479c-.776-.149-.933-.251-1.11-.283l-3.396-.553c.116-.032-.397-.137-.533-.298L12.45 2.692l-.14-.068 3.321 6.306c.039.068.068.79.086.219.105.439-.167 1.151-.607.986.29.021-.215.024-.323.009L7.66 8.986a.872.872 0 0 1-.257-.094.815.815 0 0 1-.302-.284L4.354 4.87l.596-.52 1.485 5.573 16.098 2.612a.553.553 0 0 0 .368-.078c.256-.161.335-.499.849-.756z"
                                  ></path>
                                </svg>
                              }
                              errorMessage={ele.error.destErrMsg}
                              // errorMessage={((ele.destValue.length && ele.srcValue.length) && (ele.srcValue === ele.destValue)) ? "Origin and destination cannot be same" : "Please enter destination city"}
                              isError={ele.error.destErrMsg ? true : false}
                              // airPortName={this.state.goingToAirPortName}
                            />
                          </div>
                          <div
                            className={
                              this.props.styles.mob_flight_search_column +
                              " " +
                              this.props.styles
                                .mob_flight_search_depart_going_date
                            }
                          >
                            <MobileCalender
                              label="Departure"
                              id="flight_departure"
                              styles={this.props.styles}
                              value={ele.departureDate || ""}
                              placholder="Departure Date"
                              onChangeDate={(value) => {
                                this.onChangeDepartureGoingDateValue(
                                  value,
                                  "departure",
                                  id
                                );
                              }}
                              startDate={ele.departureDate || ""}
                              endDate={ele.returnDate || ""}
                              startDateLimit={ele.disabledDate || ""}
                              dateFormat={"DD-MMM-YYYY"}
                              changeVisibility={(bool) => {
                                this.onchangeVisibility(bool, "departure", id);
                              }}
                              isVisible={ele.showdepartureDateDropdown}
                              type={"double"}
                              doubleSelection={false}
                              totalMonths={12}
                              DisableReturnDate={
                                this.state.selectedTripType == "oneWay"
                              }
                              iconImage={
                                <svg width="19" height="19">
                                  <path
                                    fill-rule="evenodd"
                                    fill="#01445F"
                                    d="M11.971.693c0-.383.378-.693.846-.693.468 0 .847.31.847.693v3.039c0 .383-.379.694-.847.694-.468 0-.846-.311-.846-.694V.693zM9.697 15.226c-.05 0-.089-.056-.089-.469 0-.26.039-.47.089-.47h2.433c.5 0-.027.21-.027.47 0 .413.527.469.027.469H9.697zM2.324 9.84c-.049 0-.089-.21-.089-.469 0-.26.04-.47.089-.47h2.317c.05 0 .089.21.089.47 0 .259-.039.469-.089.469H2.324zm3.786 0c-.149 0-.189-.21-.189-.469 0-.26.04-.47.189-.47h2.217c.05 0 .09.21.09.47 0 .259-.04.469-.09.469H6.11zm3.587 0c-.05 0-.089-.21-.089-.469 0-.26.039-.47.089-.47h2.433c.5 0-.027.21-.027.47 0 .259.527.469.027.469H9.697zm3.688 0c-.05 0-.09-.21-.09-.469 0-.26.04-.47.09-.47h2.316c.05 0 .09.21.09.47 0 .259-.04.469-.09.469h-2.316zM2.324 12.533c-.049 0-.089-.209-.089.107 0-.836.04-1.046.089-1.046h2.317c.05 0 .089.21.089 1.046 0-.316-.039-.107-.089-.107H2.324zm3.786 0c-.149 0-.189-.209-.189.107 0-.836.04-1.046.189-1.046h2.217c.05 0 .09.21.09 1.046 0-.316-.04-.107-.09-.107H6.11zm3.587 0c-.05 0-.089-.209-.089.107 0-.836.039-1.046.089-1.046h2.433c.5 0-.027.21-.027 1.046 0-.316.527-.107.027-.107H9.697zm3.688 0c-.05 0-.09-.209-.09.107 0-.836.04-1.046.09-1.046h2.316c.05 0 .09.21.09 1.046 0-.316-.04-.107-.09-.107h-2.316zM2.324 15.226c-.049 0-.089-.056-.089-.469 0-.26.04-.47.089-.47h2.317c.05 0 .089.21.089.47 0 .413-.039.469-.089.469H2.324zm3.786 0c-.149 0-.189-.056-.189-.469 0-.26.04-.47.189-.47h2.217c.05 0 .09.21.09.47 0 .413-.04.469-.09.469H6.11zM4.343.693c0-.383.378-.693.846-.693.468 0 1.171.31 1.171.693v3.039c0 .383-.703.694-1.171.694-.468 0-.846-.311-.846-.694V.693zM.938 6.647H17.84V3.149c0 .161-.48-.225-.882-.304a.424.424 0 0 0-.303-.126h-1.546a.47.47 0 1 1 0-.939h1.547c.674 0 .719.154.967.402.248.248.627.59.627.967v13.507c0 .674-.379.719-.627.967s-.293.627-.967.627H1.368c-.377 0-.719-.379-.967-.627C.153 17.374 0 17.32 0 16.655V3.149c0-.377.153-.719.401-.967.248-.248.59-.402.967-.402H3.21c.071 0 .281.21.281.469 0 .26-.21.47-.281.47H1.368c-.117 0-.224.048.272.126-.653.078-.702.455-.702.304v3.498zm16.922.94H.938v9.068c0 .117.049.224.702.304-.498.401-.391.891-.272.891h15.288c.118 0 .225-.49.304-.891.42-.078.9-.185.9-.304V7.587zM7.397 2.719a.469.469 0 1 1 0-.939h3.152c.26 0 .641.21.641.469 0 .26-.381.47-.641.47H7.397z"
                                  ></path>
                                </svg>
                              }
                            />
                            {/* <svg xmlns="http://www.w3.org/2000/svg" className={this.props.styles.modify_icons}><path fill-rule="evenodd" fill="#01445F" d="M11.971.693c0-.383.378-.693.846-.693.468 0 .847.31.847.693v3.039c0 .383-.379.694-.847.694-.468 0-.846-.311-.846-.694V.693zM9.697 15.226c-.05 0-.089-.056-.089-.469 0-.26.039-.47.089-.47h2.433c.5 0-.027.21-.027.47 0 .413.527.469.027.469H9.697zM2.324 9.84c-.049 0-.089-.21-.089-.469 0-.26.04-.47.089-.47h2.317c.05 0 .089.21.089.47 0 .259-.039.469-.089.469H2.324zm3.786 0c-.149 0-.189-.21-.189-.469 0-.26.04-.47.189-.47h2.217c.05 0 .09.21.09.47 0 .259-.04.469-.09.469H6.11zm3.587 0c-.05 0-.089-.21-.089-.469 0-.26.039-.47.089-.47h2.433c.5 0-.027.21-.027.47 0 .259.527.469.027.469H9.697zm3.688 0c-.05 0-.09-.21-.09-.469 0-.26.04-.47.09-.47h2.316c.05 0 .09.21.09.47 0 .259-.04.469-.09.469h-2.316zM2.324 12.533c-.049 0-.089-.209-.089.107 0-.836.04-1.046.089-1.046h2.317c.05 0 .089.21.089 1.046 0-.316-.039-.107-.089-.107H2.324zm3.786 0c-.149 0-.189-.209-.189.107 0-.836.04-1.046.189-1.046h2.217c.05 0 .09.21.09 1.046 0-.316-.04-.107-.09-.107H6.11zm3.587 0c-.05 0-.089-.209-.089.107 0-.836.039-1.046.089-1.046h2.433c.5 0-.027.21-.027 1.046 0-.316.527-.107.027-.107H9.697zm3.688 0c-.05 0-.09-.209-.09.107 0-.836.04-1.046.09-1.046h2.316c.05 0 .09.21.09 1.046 0-.316-.04-.107-.09-.107h-2.316zM2.324 15.226c-.049 0-.089-.056-.089-.469 0-.26.04-.47.089-.47h2.317c.05 0 .089.21.089.47 0 .413-.039.469-.089.469H2.324zm3.786 0c-.149 0-.189-.056-.189-.469 0-.26.04-.47.189-.47h2.217c.05 0 .09.21.09.47 0 .413-.04.469-.09.469H6.11zM4.343.693c0-.383.378-.693.846-.693.468 0 1.171.31 1.171.693v3.039c0 .383-.703.694-1.171.694-.468 0-.846-.311-.846-.694V.693zM.938 6.647H17.84V3.149c0 .161-.48-.225-.882-.304a.424.424 0 0 0-.303-.126h-1.546a.47.47 0 1 1 0-.939h1.547c.674 0 .719.154.967.402.248.248.627.59.627.967v13.507c0 .674-.379.719-.627.967s-.293.627-.967.627H1.368c-.377 0-.719-.379-.967-.627C.153 17.374 0 17.32 0 16.655V3.149c0-.377.153-.719.401-.967.248-.248.59-.402.967-.402H3.21c.071 0 .281.21.281.469 0 .26-.21.47-.281.47H1.368c-.117 0-.224.048.272.126-.653.078-.702.455-.702.304v3.498zm16.922.94H.938v9.068c0 .117.049.224.702.304-.498.401-.391.891-.272.891h15.288c.118 0 .225-.49.304-.891.42-.078.9-.185.9-.304V7.587zM7.397 2.719a.469.469 0 1 1 0-.939h3.152c.26 0 .641.21.641.469 0 .26-.381.47-.641.47H7.397z"></path></svg> */}
                          </div>
                          {this.state.selectedTripType === "roundTrip" &&
                          this.state.isAdvanceSearch === false ? (
                            <div
                              className={
                                this.props.styles.mob_flight_search_column +
                                " " +
                                this.props.styles
                                  .mob_flight_search_depart_going_date
                              }
                            >
                              <MobileCalender
                                label="Return"
                                id="flight_return"
                                styles={this.props.styles}
                                value={ele.returnDate || ""}
                                placholder="Arrival Date"
                                onChangeDate={(value) => {
                                  this.onChangeDepartureGoingDateValue(
                                    value,
                                    "return",
                                    id
                                  );
                                }}
                                startDate={ele.departureDate || ""}
                                endDate={ele.returnDate || ""}
                                startDateLimit={
                                  ele.departureDate
                                    ? ele.departureDate
                                    : ele.disabledDate
                                    ? ele.disabledDate
                                    : todaysDate
                                }
                                dateFormat={"DD-MMM-YYYY"}
                                changeVisibility={(bool) => {
                                  this.onchangeVisibility(bool, "return", id);
                                }}
                                isVisible={ele.showreturnDateDropdown}
                                type={"double"}
                                doubleSelection={false}
                                totalMonths={12}
                                DisableReturnDate={
                                  this.state.selectedTripType == "oneWay"
                                }
                                iconImage={
                                  <svg width="19" height="19">
                                    <path
                                      fill-rule="evenodd"
                                      fill="#01445F"
                                      d="M11.971.693c0-.383.378-.693.846-.693.468 0 .847.31.847.693v3.039c0 .383-.379.694-.847.694-.468 0-.846-.311-.846-.694V.693zM9.697 15.226c-.05 0-.089-.056-.089-.469 0-.26.039-.47.089-.47h2.433c.5 0-.027.21-.027.47 0 .413.527.469.027.469H9.697zM2.324 9.84c-.049 0-.089-.21-.089-.469 0-.26.04-.47.089-.47h2.317c.05 0 .089.21.089.47 0 .259-.039.469-.089.469H2.324zm3.786 0c-.149 0-.189-.21-.189-.469 0-.26.04-.47.189-.47h2.217c.05 0 .09.21.09.47 0 .259-.04.469-.09.469H6.11zm3.587 0c-.05 0-.089-.21-.089-.469 0-.26.039-.47.089-.47h2.433c.5 0-.027.21-.027.47 0 .259.527.469.027.469H9.697zm3.688 0c-.05 0-.09-.21-.09-.469 0-.26.04-.47.09-.47h2.316c.05 0 .09.21.09.47 0 .259-.04.469-.09.469h-2.316zM2.324 12.533c-.049 0-.089-.209-.089.107 0-.836.04-1.046.089-1.046h2.317c.05 0 .089.21.089 1.046 0-.316-.039-.107-.089-.107H2.324zm3.786 0c-.149 0-.189-.209-.189.107 0-.836.04-1.046.189-1.046h2.217c.05 0 .09.21.09 1.046 0-.316-.04-.107-.09-.107H6.11zm3.587 0c-.05 0-.089-.209-.089.107 0-.836.039-1.046.089-1.046h2.433c.5 0-.027.21-.027 1.046 0-.316.527-.107.027-.107H9.697zm3.688 0c-.05 0-.09-.209-.09.107 0-.836.04-1.046.09-1.046h2.316c.05 0 .09.21.09 1.046 0-.316-.04-.107-.09-.107h-2.316zM2.324 15.226c-.049 0-.089-.056-.089-.469 0-.26.04-.47.089-.47h2.317c.05 0 .089.21.089.47 0 .413-.039.469-.089.469H2.324zm3.786 0c-.149 0-.189-.056-.189-.469 0-.26.04-.47.189-.47h2.217c.05 0 .09.21.09.47 0 .413-.04.469-.09.469H6.11zM4.343.693c0-.383.378-.693.846-.693.468 0 1.171.31 1.171.693v3.039c0 .383-.703.694-1.171.694-.468 0-.846-.311-.846-.694V.693zM.938 6.647H17.84V3.149c0 .161-.48-.225-.882-.304a.424.424 0 0 0-.303-.126h-1.546a.47.47 0 1 1 0-.939h1.547c.674 0 .719.154.967.402.248.248.627.59.627.967v13.507c0 .674-.379.719-.627.967s-.293.627-.967.627H1.368c-.377 0-.719-.379-.967-.627C.153 17.374 0 17.32 0 16.655V3.149c0-.377.153-.719.401-.967.248-.248.59-.402.967-.402H3.21c.071 0 .281.21.281.469 0 .26-.21.47-.281.47H1.368c-.117 0-.224.048.272.126-.653.078-.702.455-.702.304v3.498zm16.922.94H.938v9.068c0 .117.049.224.702.304-.498.401-.391.891-.272.891h15.288c.118 0 .225-.49.304-.891.42-.078.9-.185.9-.304V7.587zM7.397 2.719a.469.469 0 1 1 0-.939h3.152c.26 0 .641.21.641.469 0 .26-.381.47-.641.47H7.397z"
                                    ></path>
                                  </svg>
                                }
                                // selectTripbtn={()=>{this.onselectTrip({ id: 2, value: "roundTrip", label: 'Round Trip'})}}
                              />
                            </div>
                          ) : null}
                          {this.state.isAdvanceSearch
                            ? this.cabinClassEle(ele, id)
                            : null}

                          {this.state.isAdvanceSearch ? (
                            <div className={this.props.styles.advn_box}>
                              <div>
                                <label
                                  htmlFor="fname"
                                  className="lablename-htl"
                                >
                                  RBD / Class
                                </label>
                              </div>

                              <div
                                className={this.props.styles.inner_rbd}
                                onClick={this.onRBDClick}
                              >
                                <div
                                  className={`${this.props.styles.inn_icn} ${this.props.styles.inner_rbdIcon}`}
                                >
                                  <svg
                                    width="20px"
                                    height="20px"
                                    viewBox="0 0 200 200"
                                  >
                                    <g>
                                      <path
                                        fill="#30C8CA"
                                        d="M100,188.716c-48.918,0-88.716-39.798-88.716-88.716S51.082,11.284,100,11.284S188.716,51.082,188.716,100 S148.918,188.716,100,188.716z M45.883,162.507c14.516,12.586,33.442,20.209,54.117,20.209c20.675,0,39.602-7.624,54.118-20.209 c-1.134-27.888-38.089-30.935-54.118-30.935S47.016,134.62,45.883,162.507z M100,17.284c-45.61,0-82.716,37.106-82.716,82.716 c0,22.237,8.82,42.452,23.146,57.331c1.983-10.823,9.079-19.279,20.815-24.682c12.708-5.85,28.09-7.077,38.755-7.077 c10.666,0,26.048,1.228,38.756,7.077c11.736,5.402,18.832,13.858,20.814,24.682c14.326-14.88,23.146-35.094,23.146-57.331 C182.716,54.39,145.609,17.284,100,17.284z M100,103c-17.409,0-31.572-14.163-31.572-31.572c0-17.409,14.163-31.572,31.572-31.572 c17.409,0,31.572,14.163,31.572,31.572C131.572,88.837,117.409,103,100,103z M100,45.856c-14.1,0-25.572,11.472-25.572,25.572 C74.428,85.528,85.9,97,100,97c14.101,0,25.572-11.472,25.572-25.572C125.572,57.328,114.101,45.856,100,45.856z"
                                      ></path>
                                    </g>
                                  </svg>
                                </div>
                                {this.RBDClassDropdown(id)}
                              </div>
                              {ele.error.rbdCabinErrMsg ? (
                                <span className={this.props.styles.rbderr}>
                                  {ele.error.rbdCabinErrMsg}
                                </span>
                              ) : null}
                            </div>
                          ) : null}
                        </div>

                        {this.state.isAdvanceSearch &&
                        ((this.state.selectedTripType === "roundTrip" &&
                          id == 1) ||
                          this.state.selectedTripType != "roundTrip") ? (
                          <div className={this.props.styles.advn_box}>
                            <div>
                              <label htmlFor="fname" className="lablename-htl">
                                Airlines
                              </label>
                            </div>

                            <div className={this.props.styles.inner_rbd}>
                              <div className={this.props.styles.inn_icn}>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="26"
                                  height="13"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    fill="#01445F"
                                    d="m.924 8.43 6.713 4.373a.93.93 0 0 0 .474.152 1.02 1.02 0 0 0 .331-.07l15.377-6.762c1.709-.712 1.705-3.328-.045-4.004a2.296 2.296 0 0 0-1.807 0L19.64 3.401 9.526.212a.79.79 0 0 0-.589.029l-2.253.99c-.413.183.166.667-.417 1.08a.822.822 0 0 0 .376.398l6.46 3.581-4.689 2.67-4.768-3.161a.82.82 0 0 0-.682 0l-1.294.819C.652 6.797.46 7.278.639 7.694c.06.14.159.261.285.736zm2.354-.989L8.45 9.733c-.277.06-.136.085.004.074a.866.866 0 0 0 .266-.061l6.607-2.915a1.02 1.02 0 0 0 .266-.184.82.82 0 0 0-.221-1.294L8.916 2.29l.389-.433 9.542 3.603c.633-.353.418.46.609.04l3.148-1.882a.67.67 0 0 1 .52 0c.274.127.393 1.102.265.728a.54.54 0 0 1-.265.266L8.205 11.199 3.33 7.539l-.052-.098z"
                                  />
                                </svg>
                              </div>
                              {this.AirlineClassDropdown(id)}
                            </div>
                          </div>
                        ) : null}

                        {this.state.isAdvanceSearch ? (
                          <div className={this.props.styles.advn_box}>
                            <div
                              className={
                                this.props.styles.mob_flight_search_column +
                                " " +
                                this.props.styles.mob_flight_search_depart
                              }
                            >
                              <label htmlFor="fname" className="lablename-htl">
                                Departure Time
                              </label>
                              <div className={this.props.styles.inner_flex}>
                                <div className={this.props.styles.inner_depart}>
                                  <span className={this.props.styles.inn_icn}>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="20"
                                      height="19"
                                    >
                                      <path
                                        fill-rule="evenodd"
                                        fill="#01445F"
                                        d="M7.668 18.778H1.577c-.42 0-.761-.341-.761-.608 0-.574.341-.915.761-.915h6.091c1.212 0 .761.341.761.915 0 .267.451.608-.761.608zm-1.523-3.047H1.577a.762.762 0 0 1 0-1.523h4.568a.76.76 0 1 1 0 1.523zm-1.523-3.047H1.577a.762.762 0 0 1 0-1.524h3.045c.808 0 .762.341.762.762s.046.762-.762.762zm6.091 6.06c-.42.019-.776-.307-.795-.584-.019-.564.307-.921.727-.939a7.618 7.618 0 0 0 6.888-8.281c-.383-4.19-4.088-7.276-8.275-6.47C5.6 2.382 2.703 5.283 2.37 8.943a.762.762 0 1 1-1.517-.137C1.309 3.778 5.751.71 10.776.527c4.709.427 9.124 4.378 9.104 9.11-.768 4.736-4.382 8.698-9.098 9.104a.814.814 0 0 1-.069.003zM9.952 5.66c-.421 0-.762-.253-.762.167v3.81c0 .202.081.683.223.538l2.284 2.286a.761.761 0 0 0 1.077-.019c.816-.295.816-.763 0-1.059l-2.061-2.062V5.827c0-.42-.341-.167-.761-.167z"
                                      />
                                    </svg>
                                  </span>
                                  {this.DepartureTimeDropdown(id)}
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : null}

                        {this.state.isAdvanceSearch ? (
                          <label
                            className={`${this.props.styles.checkbox_label} ${this.props.styles.wd_15}`}
                          >
                            <span className={this.props.styles.bagCheckbox}>
                              <input
                                type="checkbox"
                                //  checked={ele.flexiBaggage}
                                checked={true}
                                onClick={(e) => this.flexiBaggageHandler(id)}
                              />
                              <span className={this.props.styles.bagBox}>
                                <span
                                  className={this.props.styles.bagCheck}
                                ></span>
                              </span>
                            </span>
                            <span className={this.props.styles.advTitle}>
                              Flexi Baggage
                            </span>
                          </label>
                        ) : null}

                        {this.state.selectedTripType === "Multicity" &&
                        id > 1 ? (
                          <div
                            className={this.props.styles.remove_icon}
                            onClick={() => {
                              this.removeList(id);
                            }}
                          >
                            {this.crossIcon()}
                          </div>
                        ) : null}
                      </>
                    );
                  })}

                {this.state.isAdvanceSearch
                  ? this.traveller()
                  : this.travellerCabinEle()}

                <div className={this.props.styles.advn_box}>
                  <div>
                    <label htmlFor="fname" className="lablename-htl">
                      Supplier
                    </label>
                  </div>
                  <div className={this.props.styles.supplir_flx}>
                    <div
                      className={`${this.props.styles.inner_rbdIcon} ${this.props.styles.inn_icn}`}
                    >
                      <svg width="20px" height="20px" viewBox="0 0 200 200">
                        <g>
                          <path
                            fill="#01445f"
                            d="M100,188.716c-48.918,0-88.716-39.798-88.716-88.716S51.082,11.284,100,11.284S188.716,51.082,188.716,100 S148.918,188.716,100,188.716z M45.883,162.507c14.516,12.586,33.442,20.209,54.117,20.209c20.675,0,39.602-7.624,54.118-20.209 c-1.134-27.888-38.089-30.935-54.118-30.935S47.016,134.62,45.883,162.507z M100,17.284c-45.61,0-82.716,37.106-82.716,82.716 c0,22.237,8.82,42.452,23.146,57.331c1.983-10.823,9.079-19.279,20.815-24.682c12.708-5.85,28.09-7.077,38.755-7.077 c10.666,0,26.048,1.228,38.756,7.077c11.736,5.402,18.832,13.858,20.814,24.682c14.326-14.88,23.146-35.094,23.146-57.331 C182.716,54.39,145.609,17.284,100,17.284z M100,103c-17.409,0-31.572-14.163-31.572-31.572c0-17.409,14.163-31.572,31.572-31.572 c17.409,0,31.572,14.163,31.572,31.572C131.572,88.837,117.409,103,100,103z M100,45.856c-14.1,0-25.572,11.472-25.572,25.572 C74.428,85.528,85.9,97,100,97c14.101,0,25.572-11.472,25.572-25.572C125.572,57.328,114.101,45.856,100,45.856z"
                          ></path>
                        </g>
                      </svg>
                    </div>
                    <div id='hotels_srp_${buttonState ? "Hide Options" : "More Options"}' className={this.props.styles.main_dropMulti}>
                      {this.props.multiSelectSupplierDropdown()}
                    </div>
                  </div>
                </div>

                <div
                  className={
                    this.props.styles.mob_flight_search_column +
                    " " +
                    this.props.styles.mob_flight_search_pax
                  }
                >
                  <div className={this.props.styles.flight_trav_title}>
                    Select Fare Type
                  </div>
                  <div className={this.props.styles.fare_flx}>
                    <span className={this.props.styles.inn_icn}>
                      <svg width="20px" height="20px" viewBox="0 0 200 200">
                        <g>
                          <path
                            fill="#01445f"
                            d="M100,188.716c-48.918,0-88.716-39.798-88.716-88.716S51.082,11.284,100,11.284S188.716,51.082,188.716,100 S148.918,188.716,100,188.716z M45.883,162.507c14.516,12.586,33.442,20.209,54.117,20.209c20.675,0,39.602-7.624,54.118-20.209 c-1.134-27.888-38.089-30.935-54.118-30.935S47.016,134.62,45.883,162.507z M100,17.284c-45.61,0-82.716,37.106-82.716,82.716 c0,22.237,8.82,42.452,23.146,57.331c1.983-10.823,9.079-19.279,20.815-24.682c12.708-5.85,28.09-7.077,38.755-7.077 c10.666,0,26.048,1.228,38.756,7.077c11.736,5.402,18.832,13.858,20.814,24.682c14.326-14.88,23.146-35.094,23.146-57.331 C182.716,54.39,145.609,17.284,100,17.284z M100,103c-17.409,0-31.572-14.163-31.572-31.572c0-17.409,14.163-31.572,31.572-31.572 c17.409,0,31.572,14.163,31.572,31.572C131.572,88.837,117.409,103,100,103z M100,45.856c-14.1,0-25.572,11.472-25.572,25.572 C74.428,85.528,85.9,97,100,97c14.101,0,25.572-11.472,25.572-25.572C125.572,57.328,114.101,45.856,100,45.856z"
                          ></path>
                        </g>
                      </svg>
                    </span>
                    <div className={this.props.styles.adv_fareType_flx}>
                      {this.props.selectFareTypeDropdown()}
                    </div>
                  </div>
                </div>

                {/* main content end */}

                {this.state.selectedTripType === "Multicity"
                  ? this.state.FlightData &&
                    this.state.FlightData.length <= 5 && (
                      <div className={this.props.styles.search_button_section}>
                        <button onClick={this.AddFlightButton}>
                          Add More flight(
                          {this.state.FlightData.length <= 2
                            ? 4
                            : this.state.FlightData.length === 3
                            ? 3
                            : this.state.FlightData.length === 4
                            ? 2
                            : 1}
                          Max) +
                        </button>
                      </div>
                    )
                  : null}

                {/* search button */}
                <div
                  className={this.props.styles.mob_flight_search_details_main}
                >
                  <div
                    className={this.props.styles.mob_flight_search_details_row}
                  >
                    <div className={this.props.styles.btn_search}
                    id="search_button"
                    >
                      <button
                        className={
                          this.props.styles.mob_flight_search_widget_btn
                        }
                        onClick={() => this.onClickSearchFlight()}
                      >
                        Search Flights
                      </button>
                    </div>
                  </div>
                </div>

                {/* search button end */}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
}
